import { useRef, useState } from 'react';
import '../../../styles/Input.css';
import { InputLabelColor, TextAreaProps } from './TextArea.types';
import { useAutosizeTextArea } from '../../../hooks/useAutosizeTextArea/useAutosizeTextArea';

export default ({
  label,
  labelColor = InputLabelColor.Dark,
  error,
  required,
  divProps,
  onChange,
  isCompany,
  onlyInput,
  className,
  ...props
}: TextAreaProps) => {
  const [value, setValue] = useState(props.value as string);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useAutosizeTextArea(textAreaRef.current, value);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target?.value;
    // @ts-ignore
    onChange(e);
    setValue(val);
  };

  if (onlyInput)
    return (
      <textarea
        ref={textAreaRef}
        className={`input__input${isCompany ? ' input__input--company' : ''} ${className || ''}`}
        onChange={handleChange}
        {...props}
      />
    );

  return (
    <div className="input" {...divProps}>
      <label
        className="input__label font-bold"
        style={{ color: labelColor === InputLabelColor.Light ? '#fff' : '#000' }}>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </label>
      {/* <div className="input__textarea-box"> */}
      <textarea
        ref={textAreaRef}
        className={`input__input${isCompany ? ' input__input--company' : ''} ${className || ''}`}
        onChange={handleChange}
        {...props}
      />
      {/* </div> */}
      <span className="input__error">{error}</span>
    </div>
  );
};
